var React = require('react');

function MailIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M20 20H4a2 2 0 01-2-2V5.913A2 2 0 014 4h16a2 2 0 012 2v12a2 2 0 01-2 2zM4 7.868V18h16V7.868L12 13.2 4 7.868zM4.8 6l7.2 4.8L19.2 6H4.8z","fill":"#2E3A59","key":1})]);
}

MailIcon.defaultProps = {"width":"30","height":"24","fill":"none"};

module.exports = MailIcon;

MailIcon.default = MailIcon;
